var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { assignTaskToUser, changeTaskDoneStatusRequest, changeTaskStageRequest, getTaskDataRequest, unAssignTaskFromUser, } from "../../api/user-page-api";
import { UserPageAppContext } from "../../providers/UserPageAppContextProvider";
import { useErrorHandler } from "../useErrorHandler";
function useTaskActions() {
    const { state: { pageHash }, } = useContext(UserPageAppContext);
    const { handleError } = useErrorHandler();
    const getTask = (pageHash, taskHash, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield getTaskDataRequest(pageHash, taskHash);
            if (callback)
                callback(response.data);
        }
        catch (error) {
            handleError(error);
        }
    });
    const assignToTask = (pageHash, taskHash, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield assignTaskToUser(pageHash, taskHash);
            toast.success(__("Task assigned successfully", "quicktasker"));
            if (callback)
                callback(response.data);
        }
        catch (error) {
            handleError(error);
        }
    });
    const unAssignFromTask = (pageHash, taskHash, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield unAssignTaskFromUser(pageHash, taskHash);
            toast.success(__("Task unassigned successfully", "quicktasker"));
            if (callback)
                callback(response.data);
        }
        catch (error) {
            handleError(error);
        }
    });
    const changeTaskStage = (taskHash, stageId, pageHash, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield changeTaskStageRequest(pageHash, taskHash, stageId);
            toast.success(__("Task stage changed successfully", "quicktasker"));
            if (callback)
                callback();
        }
        catch (error) {
            handleError(error);
        }
    });
    const changeTaskDoneStatus = (taskHash, doneStatus, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            const successMessage = doneStatus
                ? __("Task marked as completed", "quicktasker")
                : __("Task marked as incomplete", "quicktasker");
            yield changeTaskDoneStatusRequest(pageHash, taskHash, doneStatus);
            toast.success(successMessage);
            if (callback)
                callback(doneStatus);
        }
        catch (error) {
            handleError(error);
        }
    });
    return {
        getTask,
        assignToTask,
        changeTaskStage,
        unAssignFromTask,
        changeTaskDoneStatus,
    };
}
export { useTaskActions };
